import React from "react";
import { SegmentedControl } from "../../../components/ui";

// i2-visual-identity-v2.md §10.1 A8 — Marketplace density toggle.
//
// Mirrors features/library/iphone-grid/DensityToggle.jsx but persists
// to a separate `marketplace.density` localStorage key so Library and
// Marketplace can be tuned independently. v1 §20.5 originally
// excluded this control on Marketplace as a visual differentiation
// rule; v2 §15 #2 reverses that — the §20.5 invariant that survives
// is "no status dot on Marketplace tiles" (V10), not density.
//
// Sizes per v2 §6.2:
//   comfortable — 96px IconTile (current default; full meta + tags)
//   compact     — 64px IconTile (sub-row hidden; faster scan at scale)
//
// Auto-flip rule (handled by parent MarketplaceView per A9):
//   templates.length > 50 AND no localStorage override → flip to compact.

const STORE_KEY = "marketplace.density";

export function readMarketplaceDensity() {
  try { return localStorage.getItem(STORE_KEY) || "comfortable"; }
  catch { return "comfortable"; }
}

export function writeMarketplaceDensity(d) {
  try { localStorage.setItem(STORE_KEY, d); } catch {}
}

const OPTIONS = [
  { value: "comfortable", label: "Comfy",   title: "Comfortable density (96px tiles)" },
  { value: "compact",     label: "Compact", title: "Compact density (64px tiles)"     },
];

export default function MarketplaceDensityToggle({ density, onChange }) {
  return (
    <div data-testid="marketplace-density-toggle">
      <SegmentedControl
        value={density}
        onChange={(next) => { writeMarketplaceDensity(next); onChange(next); }}
        options={OPTIONS}
      />
    </div>
  );
}
